import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface NotFoundProps{
	code?: string,
	subtext?: string,
	style?: React.CSSProperties
}

var NotFound = (props: NotFoundProps)=>{
	var { t } = useTranslation();
	return <div className="fr centered header" style={{ fontSize: 100, ...props.style }}>
		{props.code || t('notfound.code')}
		<div className="sub header" style={{ fontSize: 20 }}>
			{props.subtext || t('notfound.message')}
		</div>
	</div>
}

export default NotFound;